import { T, useT } from "@repo/transifex";
import { ReportCard, ReportPriceRow, ReportRow } from "~/components/report";

import { type CashDrawerData } from "./types";
import { negatePrice } from "./utils";

type CashDrawerSectionProps = {
  data: CashDrawerData;
};

export const CashDrawerSection = ({ data }: CashDrawerSectionProps) => {
  const t = useT();

  const overShortDisplay = data.overShort === "balanced" ? "=" : undefined;

  return (
    <ReportCard title={<T _str="Cash Drawer Summary" />}>
      <ReportPriceRow
        label={t("Opening Float")}
        value={data.openingFloat}
        currency={data.currency}
      />
      <ReportPriceRow
        label={t("Cash Sales")}
        value={data.cashSales}
        currency={data.currency}
      />
      <ReportPriceRow
        label={t("Cash Refunds")}
        value={negatePrice(data.cashRefunds)}
        currency={data.currency}
      />
      <ReportPriceRow
        label={t("Expected Cash in Drawer")}
        value={data.expectedCash}
        currency={data.currency}
      />
      <ReportPriceRow
        label={t("Actual Counted Cash")}
        value={data.actualCash}
        currency={data.currency}
      />
      {overShortDisplay ? (
        <ReportRow label={t("Over / Short")} value={overShortDisplay} />
      ) : (
        <ReportPriceRow
          label={t("Over / Short")}
          value={data.overShort}
          currency={data.currency}
        />
      )}
      <ReportRow
        label={t("Times cash drawer opened manually")}
        value={data.manualOpenings}
      />
      <ReportRow
        label={t("Times cash drawer opened automatically")}
        value={data.automaticOpenings}
      />
    </ReportCard>
  );
};
